// Parse response content that is a JSON-encoded list of things,
// for example "list.number" or "list.latlon"
export function parseResponseContentList(content) {
    let contentList = null;
    try {
        contentList = JSON.parse(content);
    }
    catch (error) {
        // Silently ignore JSON errors
        return [];
    }
    return Array.isArray(contentList) ? contentList : [];
}
// Parse "latlon" response content, returning an array with two elements
// ordered as [latitude, longitude]
export function parseGeoResponseContentPointLatLon(content) {
    const parts = typeof (content) === "string" ? content.split(",") : [];
    return [+parts[0] || 0, +parts[1] || 0];
}
// Parse "latlon" response content, returning an array with two elements
// ordered as [longitude, latitude]
export function parseGeoResponseContentPointLonLat(content) {
    const parts = typeof (content) === "string" ? content.split(",") : [];
    return [+parts[1] || 0, +parts[0] || 0];
}
export function parseGeoResponseContentPointListLatLon(content) {
    const list = parseResponseContentList(content);
    return list.map(parseGeoResponseContentPointLatLon);
}
export function parseGeoResponseContentPointListLonLat(content) {
    const list = parseResponseContentList(content);
    return list.map(parseGeoResponseContentPointLonLat);
}
export function parseGeoResponseContentPointListListLatLon(content) {
    const list = parseResponseContentList(content);
    return list.map((points) => (Array.isArray(points) ?
        points.map(parseGeoResponseContentPointLatLon) : []));
}
export function parseGeoResponseContentPointListListLonLat(content) {
    const list = parseResponseContentList(content);
    return list.map((points) => (Array.isArray(points) ?
        points.map(parseGeoResponseContentPointLonLat) : []));
}
// Parse a geo response content string, returning points as
// arrays in [lat, lon] order.
// Returns an empty array if the content type was unrecognized.
// Content type "latlon" produces a single [lat, lon] point
// "list.latlon" produces an array of [lat, lon] points
// "list.list.latlon" produces an array of arrays of [lat, lon] points
export function parseGeoResponseContentLatLon(content, contentType) {
    if (contentType === "latlon") {
        return parseGeoResponseContentPointLatLon(content);
    }
    else if (contentType === "list.latlon") {
        return parseGeoResponseContentPointListLatLon(content);
    }
    else if (contentType === "list.list.latlon") {
        return parseGeoResponseContentPointListListLatLon(content);
    }
    else {
        return [];
    }
}
// Parse a geo response content string, returning points as
// arrays in [lon, lat] order.
// Returns an empty array if the content type was unrecognized.
// Content type "latlon" produces a single [lon, lat] point
// "list.latlon" produces an array of [lon, lat] points
// "list.list.latlon" produces an array of arrays of [lon, lat] points
export function parseGeoResponseContentLonLat(content, contentType) {
    if (contentType === "latlon") {
        return parseGeoResponseContentPointLonLat(content);
    }
    else if (contentType === "list.latlon") {
        return parseGeoResponseContentPointListLonLat(content);
    }
    else if (contentType === "list.list.latlon") {
        return parseGeoResponseContentPointListListLonLat(content);
    }
    else {
        return [];
    }
}
//# sourceMappingURL=responseContent.js.map